import React, { type ReactNode } from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, type BoxProps } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		position: 'relative',
		borderRadius: token('border.radius.200'),
		borderWidth: token('border.width'),
		borderColor: token('color.border'),
		borderStyle: 'solid',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.150'),
		maxWidth: '100%',
	},
	extraPadding: {
		paddingTop: token('space.250'),
		paddingRight: token('space.400'),
		paddingBottom: token('space.250'),
		paddingLeft: token('space.400'),
	},
});

// Can expand T as required
type Props = {
	testId?: string;
	extraPadding?: boolean;
	children: ReactNode;
	/**
	 * @deprecated use testId instead
	 */
	testSelector?: string;
} & BoxProps<'div'>;

export const ItemWrapper = ({ testId, children, extraPadding, testSelector, ...rest }: Props) => {
	return (
		<Box
			backgroundColor="elevation.surface"
			xcss={cx(styles.wrapper, extraPadding && styles.extraPadding)}
			testId={testId}
			data-test-selector={testSelector}
			{...rest}
		>
			{children}
		</Box>
	);
};
